// @flow
export const dataKey = 'employees';
